import * as React from 'react';

import { JRCModalLayout } from 'components/JRCModal/JRCModalLayout';
import { JRCModalLayoutProps } from 'types';

import { JRCFileViewerArrows } from './JRCFileViewerArrows';
import { JRCFileViewerProps } from './types';
import { JRCFileViewerContent } from './JRCFileViewerContent';

import {
    CSSFileViewer,
    CSSFileViewerContent,
    CSSFileViewerDownload,
    CSSFileViewerFooter,
    CSSFileViewerHeader,
    CSSFileViewerHeaderContent,
} from './JRCFileViewer.styles';
import { useIntl } from 'react-intl';
import { jFileLittle } from 'jamespot-user-api';
import { JRCModalContent } from '../JRCModal/JRCModalContent';
import { JRCTypography } from '../JRCTypography/JRCTypography';
import { JRCIcon } from '../JRCIcon/JRCIcon';

export const JRCFileViewer = <T extends jFileLittle>({
    files,
    size = 'fitx1200',
    children,
    openWithOptions,
    onReadFile,
}: JRCFileViewerProps<T>) => {
    const intl = useIntl();
    const [index, setIndex] = React.useState<number>(-1);

    React.useEffect(() => {
        if (onReadFile && index > -1) {
            const file = files[index];

            if (file) {
                onReadFile(file);
            }
        }
    }, [index, files, onReadFile]);

    const args: JRCModalLayoutProps = {
        open: index !== -1,
        portalId: 'react-modal',
        variant: 'full-screen',
        maxHeight: '100%',
        closeHandler: () => {
            setIndex(-1);
        },
    };

    return (
        <>
            {children((idFile) => {
                const file = files.find((f) => f.id === idFile);
                if (!file) {
                    return;
                }
                const options = openWithOptions.find((e) => e.condition(file));
                if (options && options.options.length > 0) {
                    options.options[0].onClick(file);
                } else {
                    setIndex(files.findIndex((file) => file.id === idFile));
                }
            })}
            <JRCModalLayout {...args}>
                <JRCModalContent
                    onClickIconClose={args.closeHandler}
                    title={intl.formatMessage({ id: 'FILE_Viewer_Preview' })}
                    isFull>
                    <CSSFileViewer data-testid="file-viewer">
                        <CSSFileViewerHeader>
                            <CSSFileViewerHeaderContent>
                                {files && files[index] && (
                                    <>
                                        {files[index].title}
                                        <CSSFileViewerDownload href={`/downloadFile.php?id=${files[index].id}`}>
                                            <JRCTypography color="grey4">
                                                {intl.formatMessage({ id: 'GLOBAL_Download' })}
                                            </JRCTypography>
                                            <JRCIcon name={'icon-download'} color={'grey4'} size={16} />
                                        </CSSFileViewerDownload>
                                    </>
                                )}
                            </CSSFileViewerHeaderContent>
                        </CSSFileViewerHeader>
                        <CSSFileViewerContent>
                            {files && files[index] && (
                                <JRCFileViewerContent
                                    file={files[index]}
                                    size={size}
                                    openWithOptions={openWithOptions}
                                />
                            )}
                        </CSSFileViewerContent>
                        <CSSFileViewerFooter>
                            <JRCFileViewerArrows
                                total={files.length}
                                index={index}
                                onRelease={(direction: string) => {
                                    switch (direction) {
                                        case 'next':
                                            setIndex(index < files.length - 1 ? index + 1 : 0);
                                            break;
                                        case 'prev':
                                            setIndex(index === 0 ? files.length - 1 : index - 1);
                                            break;
                                    }
                                }}
                            />
                        </CSSFileViewerFooter>
                    </CSSFileViewer>
                </JRCModalContent>
            </JRCModalLayout>
        </>
    );
};
